import { Menu, LogOut, User } from 'lucide-react';
import { useState } from 'react';
import useAuthStore from '../store/authStore';
import { logout } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { roleLabels } from '../utils/status';

const Header = ({ onToggleSidebar }) => {
  const { user, logout: logoutStore } = useAuthStore();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      logoutStore();
      toast.success('Sesión cerrada');
      navigate('/login');
    } catch (error) {
      toast.error('Error al cerrar sesión');
    }
  };

  return (
    <header className="sticky top-0 z-30 border-b border-gray-200 bg-white">
      <div className="flex items-center justify-between px-4 py-3 md:px-6">
        <button
          onClick={onToggleSidebar}
          className="p-2 hover:bg-gray-100 rounded-lg transition md:hidden"
        >
          <Menu className="w-6 h-6" />
        </button>

        <div className="hidden md:block">
          <h1 className="text-lg font-bold text-gray-900">Vete Suite :: Panel Veterinaria</h1>
          <p className="text-xs text-gray-500">Operacion, agenda, tienda y reportes</p>
        </div>
        <div className="flex-1" />

        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-lg transition"
          >
            <User className="w-5 h-5 text-gray-600" />
            <span className="text-sm font-medium text-gray-700 hidden md:block">
              {user?.full_name || user?.email}
            </span>
          </button>

          {showMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg">
              <div className="px-4 py-3 border-b border-gray-200">
                <p className="text-sm font-medium text-gray-800">{user?.full_name}</p>
                <p className="text-xs text-gray-600">{user?.email}</p>
                {user?.role && (
                  <p className="text-xs text-blue-600 font-medium mt-1">
                    {roleLabels[user.role] || user.role}
                  </p>
                )}
              </div>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition"
              >
                <LogOut className="w-4 h-4" />
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
